import { useState } from "react";
import { BadgeView } from "./BadgeView";
import { AchievementDetailModal } from "./AchievementDetailModal";
import { ReactComponent as ChevronDownIcon } from "../../../assets/icons/chevron-down.svg";
import { twMerge } from "tailwind-merge";
import { ACTIVE_ACHIEVEMENT_STATUSES } from "../utils/constant";

const LESS_COUNT = 4;

export function AchievementSection({ sectionName, totalCollected, total, badges = [], emptyMessage }: { sectionName: string, totalCollected: number, total: number, badges?: any[], emptyMessage: string }) {
    const [showMore, setShowMore] = useState(false);
    const [selectedAchievement, setSelectedAchievement] = useState<any>(null);
    const hasBadges = badges.length > 0;

    const toggleShowMore = () => {
        setShowMore(!showMore)
    }

    const badgeListToShow = showMore ? badges : badges.slice(0, LESS_COUNT);

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
                <div className="flex flex-col">
                    <span className="text-black text-base font-semibold">{sectionName}</span>
                    <span className="text-black text-base">{totalCollected} / {total} total collected</span>
                </div>
                {hasBadges && (
                    <button onClick={toggleShowMore} className="flex items-center gap-2 text-black text-base">
                        {showMore ? "Show Less" : "Show More"}
                        <ChevronDownIcon className={twMerge("w-6 h-6", showMore ? "rotate-180" : "")} />
                    </button>
                )}
            </div>

            {hasBadges ? (
                <div className="grid grid-cols-2 md:grid-cols-4 2xl:grid-cols-6 items-center flex-wrap justify-around gap-2">
                    {badgeListToShow.map((badge) => (
                        <button
                            key={badge.slug || badge.name}
                            type="button"
                            onClick={() => setSelectedAchievement(badge)}
                            className="hover:opacity-80 transition-opacity"
                        >
                            <BadgeView title={badge.name} data={badge} />
                        </button>
                    ))}
                </div>
            ) : (
                <span className="text-black text-base">{emptyMessage}</span>
            )}
            {selectedAchievement && (
                <AchievementDetailModal
                    achievement={selectedAchievement}
                    onClose={() => setSelectedAchievement(null)}
                />
            )}
        </div>
    )
}